/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ItemWrap } from '@/components/layouts/ItemWrap';
import { LayoutSlot } from '@/components/layouts/LayoutSlot';
import { layoutMainSX } from '@/components/layouts/styles/main';
import { Layout } from '@/data/types/Layout';
import { Grid, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { FC } from 'react';
import { DpContainer } from '@/components/blocks/DpContainer';

export const Aside: FC<{ layout: Layout }> = ({ layout }) => {
	const {
		dimensions: { contentSpacing },
	} = useTheme();

	return layout ? (
		<React.Fragment>
			<LayoutSlot slot={layout.slots.header} />
			<Stack
				component="main"
				gap={contentSpacing}
				sx={layoutMainSX(layout.slots.first?.length ?? 0)}
			>
				<LayoutSlot slot={layout.slots.first} ItemWrap={ItemWrap} />
				<DpContainer component="section">
					<Grid container spacing={contentSpacing}>
						<Grid
							item
							component="aside"
							xs={12}
							md={3}
							aria-label={layout.slots.aside?.at(0)?.name}
						>
							<Stack gap={contentSpacing}>
								<LayoutSlot slot={layout.slots.aside} />
							</Stack>
						</Grid>
						<Grid item component="section" xs={12} md={9}>
							<Stack gap={contentSpacing}>
								<LayoutSlot slot={layout.slots.second} />
							</Stack>
						</Grid>
					</Grid>
				</DpContainer>
				<LayoutSlot slot={layout.slots.footer} />
			</Stack>
		</React.Fragment>
	) : null;
};
